import { useShellSlot, useOptionalShellChrome } from "./ShellProvider";

export interface ShellDismiss {
  /** Dismisses the open overlay. False means the caller keeps its own behaviour. */
  requestDismiss: () => boolean;
  hasOverlay: boolean;
}

export function useHasOverlay(): boolean {
  const chrome = useOptionalShellChrome();

  return useShellSlot(chrome, "overlay").ownerId !== null;
}

export function useShellDismiss(): ShellDismiss {
  const chrome = useOptionalShellChrome();
  const hasOverlay = useHasOverlay();

  return { requestDismiss: chrome.requestDismiss, hasOverlay };
}
